const axios = require("axios");

//axios.defaults.baseURL = "http://localhost:3000";
axios.defaults.baseURL = process.env.REACT_APP_API_URI;
axios.defaults.headers.post["Content-Type"] = "application/json";
